// SARB reporting periods are captured twice a year — September (mid-year) and December (year-end).
export const SarbReportingMonths = {
    September: 9,
    December: 12,
};

// Shared Excel header cell style for SARB export workbooks.
export const ExcelHeaderStyle = { fontWeight: 'bold', backgroundColor: '#D9E1F2' };
